import {
  ENDPOINT_CARTS,
  ENDPOINT_ROOT,
  ENDPOINT_TOGGLE_SELECTION,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const patchToggleSelection = ({ id, select, noDis }) => {
  const params = { is_selected: select };

  // Param to un select only no available items
  if (noDis) {
    params.noDis = true;
  }

  return axiosAuth
    .patch(
      `${ENDPOINT_ROOT}/${ENDPOINT_CARTS}/${id}/${ENDPOINT_TOGGLE_SELECTION}`,
      params,
    )
    .then((res) => res.data);
};

export default patchToggleSelection;
